import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  ChartOptions,
} from "chart.js";
import { Line } from "react-chartjs-2";

// Enregistrez tous les éléments nécessaires
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title
);

interface LineChartForCategoryDashbordProps {
  title: string;
  data: any;
  options?: ChartOptions<"line">;
}

const LineChartForCategoryDashbord: React.FC<LineChartForCategoryDashbordProps> = ({
  title,
  data,
  options,
}) => {
  return (
    <div className=" bg-white rounded-lg shadow-md w-full lg:h-[400px]">
      <div className="p-4 text-md font-semibold text-gray-600 border-b border-gray-300 pb-2">
        {title}
      </div>
      <div
        className="p-4 relative w-full lg:h-[300px] flex justify-center"
        style={{ aspectRatio: "3 / 2", marginTop: 15}}
      >
        <Line
          data={data}
          options={{
            plugins: {
              legend: {
                position: "bottom",
                labels: {
                  boxWidth: 12,
                  padding: 20,
                },
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default LineChartForCategoryDashbord;

